import { useState } from "react";
import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import OrganizationLayout from "../organizations/OrganizationLayout";
import UserLayout from "../user/UserLayout";
import Paper from "@mui/material/Paper";
import { useTranslation } from 'react-i18next';

const AdminLayout = () => {
  const [view, setView] = useState("organizations");
  const { t } = useTranslation();

  const handleChange = (_, newView) => {
    if (newView) setView(newView);
  };

  return (
    <Box sx={{ position: "relative", minHeight: "100vh" }}>
      {/* Selector fijo arriba a la derecha */}
      <Paper
        elevation={6}
        sx={{
          position: "absolute",
          top: 72,
          right: 32,
          zIndex: 1300,
          p: "0.5rem 1rem",
          display: "flex",
          alignItems: "center",
          borderRadius: "0.5rem",
        }}
      >
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={handleChange}
          size="small"
        >
          <ToggleButton value="organizations">{t('organizations.title')}</ToggleButton>
          <ToggleButton value="users">{t('users.title')}</ToggleButton>
        </ToggleButtonGroup>
      </Paper>

      {/* Vista seleccionada */}
      <Box>{view === "organizations" ? <OrganizationLayout /> : <UserLayout />}</Box>
    </Box>
  );
};

export default AdminLayout;
